export function checkOk(val: any, msg?: string): asserts val {
  if (!val) {
    throw new Error(msg || `expected truthy value but got ${val}`)
  }
}
